// engine
import { StateController, autoplay, dispatcher, platform, respin, serverData } from '@aceroll/core';

// utils
import { delay } from '@aceroll/core';

// services
import winAnimation from '../services/winAnimation';

class ResultController extends StateController {
    constructor() {
        super("result");
    }

    async onStart() {
        platform.setResultDisplay();

        await Promise.all([
            this.animateWins(),
            this.spinDelay()
        ]);
        serverData.setCurrentResponse();

        this.stop();
    }

    async animateWins() {
        const slotMachine = dispatcher.app.layout.slotMachine;

        const response = serverData.currentResponse;
        const actions = response.parsed.actions;

        // Multiplier animation should be played before the total win animation because the multipliers are included to total win
        await winAnimation.playActions(actions.filter((action) => { return action.type === 'add' }));
        await winAnimation.playActions(actions.filter((action) => { return action.type === 'multiply' }));

        // play total win should show all won line symbols, total win counter, big win if needed. No lines, no scatters.
        await winAnimation.playTotalWin(response);

        if (respin.isStarted()) {
            respin.addTotalWin(response.winAmount)
        }
        const hasMaxWin = serverData.nextResponses.length === 1 && (serverData.nextResponses[0].etn === 'max_win_reached');
        if (hasMaxWin) {
            // const totalWin = respin.getTotalWin();
            await this.showBigWinPopup(response.totalWinAmount, serverData.roundBet);
            platform.setFeatureTotalWin(String(response.totalWinAmount));
            respin.stop();
        } else if (respin.isStarted() && serverData.featureCount['respin'] <= 0) {
            // const totalWin = respin.getTotalWin();
            await this.showBigWinPopup(response.totalWinAmount, serverData.roundBet);
            platform.setFeatureTotalWin(String(response.totalWinAmount));
            respin.stop();
        } else if (!respin.isStarted()) {
            await this.showBigWinPopup(response.winAmount, serverData.roundBet);
        }

        // then show respin feature land animations. 
        await winAnimation.playActions(actions.filter((item) => {
            return item.type === 'bonusfeaturewon' && item.data.name === 'respin';
        }));

        // move stick symbols to the stick container
        const sticks = actions.filter((action) => { return action.type === 'stick' });
        if (sticks.length > 0) {
            // show stick symbols animations and move to the stick container
            for (let i = 0; i < sticks.length; i++) {
                await slotMachine.stick(sticks[i].data);
            }
        }

        // if no more respins unstick all sticked symbols
        if (hasMaxWin || serverData.featureCount['respin'] <= 0) {
            slotMachine.unstickAll();
        }
    }

    async showBigWinPopup(win, bet) {
        const multiplier = Number(win) / Number(bet);
        const bigWinMinMultiplier = 20;

        if (multiplier >= bigWinMinMultiplier) {
            const popup = dispatcher.app.layout.bigWinPopup;
            platform.onceClickScreen().then(() => popup.handleSkipSequence());

            return popup.show(win, bet);
        }
    }

    async spinDelay() {
        if (autoplay.isStarted() || respin.isStarted()) {
            await delay(450);
        }
    }

    onStop() {

    }
}

export default ResultController;